// SidebarTask Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import moment from 'moment'

import PanelTaskForm from '../../panel/panel_taskform/panel_taskform.jsx'
import PanelSubtask from '../../panel/panel_subtask/panel_subtask.jsx'
import SidebarHeader from '../../layout/sidebar_header/sidebar_header.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import Acl from '../../../lib/acl.jsx'

class SidebarTask extends Component {
  constructor (props) {
    super(props)

    this._task = props.task || null
    this._nextSubtaskId = 1
    this._activities = []
    this._users = []
    this._userKeyword = ''
    this._excludeUserIds = []
    this._isViewMode = false

    this.state = {
      currentTab: 'task',
      showEdit: false
    }

    this._references = {
      uploadErrorDialog: React.createRef()
    }
  }

  static get propTypes () {
    return {
      onClose: PropTypes.func,
      user: PropTypes.object,
      projects: PropTypes.array,
      task: PropTypes.object,
      skillOptions: PropTypes.array,
      onDelete: PropTypes.func,
      onSaveAdd: PropTypes.func,
      onSaveEdit: PropTypes.func,
      onUpdateDocuments: PropTypes.func,
      onSearchUsers: PropTypes.func,
      getProjectBudgetItems: PropTypes.func,
      getTaskHours: PropTypes.func,
      onChangeDueDate: PropTypes.func,
      onCreateComment: PropTypes.func,
      onUploadError: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      onClose: null,
      user: null,
      projects: [],
      task: null,
      skillOptions: [],
      onDelete: null,
      onSaveAdd: null,
      onSaveEdit: null,
      onUpdateDocuments: null,
      onSearchUsers: null,
      getProjectBudgetItems: null,
      getTaskHours: null,
      onChangeDueDate: null,
      onCreateComment: null,
      onUploadError: null
    }
  }

  render () {
    const task = this._task
    if (!task) {
      return null
    }

    const { currentTab, showEdit } = this.state
    const {
      user,
      projects,
      skillOptions,
      onUploadError,
      getTaskHours
    } = this.props
    let allUserOptions = []

    this._users.forEach(user => {
      if (this._excludeUserIds.indexOf(user.id) === -1) {
        allUserOptions.push(user)
      }
    })

    allUserOptions = _.sortBy(allUserOptions, user => (user.checked ? 0 : 1))
    const topUserOptions = allUserOptions.slice(0, 4)
    const otherUserOptions = allUserOptions.slice(4)

    return (
      <div className='sidebar-detail sidebar-task'>
        {this._renderHeader()}
        <div className='sidebarcontent'>
          {currentTab === 'task' && (
            <div className='taskcontent'>
              <PanelTaskForm
                task={task}
                user={user}
                projects={projects}
                activities={this._activities}
                skillOptions={skillOptions}
                skills={task.skills}
                topUsers={topUserOptions}
                otherUsers={otherUserOptions}
                showEdit={showEdit}
                userKeyword={this._userKeyword}
                isViewMode={this._isViewMode}
                getTaskHours={getTaskHours}
                onCheckUser={this._onCheckUser.bind(this)}
                onDeleteUser={this._onDeleteUser.bind(this)}
                onChange={this._onChangeField.bind(this)}
                onSave={this._onSaveField.bind(this)}
                onChangeDueDate={this._onChangeDueDate.bind(this)}
                onComplete={this._onToggleCompleteTask.bind(this, true)}
                onReopen={this._onToggleCompleteTask.bind(this, false)}
                onDelete={this._onDeleteTask.bind(this)}
                onSearchUser={this._onChangeUserKeyword.bind(this)}
                onUploadFile={this._onUploadFile.bind(this)}
                onDeleteFile={this._onDeleteFile.bind(this)}
                onChangeSkill={this._onChangeSkill.bind(this)}
                onCreateComment={this._onCreateComment} // eslint-disable-line react/jsx-handler-names
                onChangeDurationTime={this._onChangeDurationTime} // eslint-disable-line react/jsx-handler-names
                onUploadError={onUploadError}
                onResetDuration={this._onResetDuration.bind(this)}
              />
            </div>
          )}
          {currentTab === 'subtask' && (
            <div className='subtaskcontent'>
              <PanelSubtask
                subtasks={task.subtasks}
                onToggleExpand={this._onToggleExpandSubtask.bind(this)}
                onAdd={this._onAddSubtask.bind(this)}
                onChange={this._onChangeSubtask.bind(this)}
                onSave={this._onSaveSubtask.bind(this)}
                onComplete={this._onToggleCompleteSubtask.bind(this, true)}
                onReopen={this._onToggleCompleteSubtask.bind(this, false)}
                onDelete={this._onDeleteSubtask.bind(this)}
              />
            </div>
          )}
        </div>
      </div>
    )
  }

  _onResetDuration () {
    this._task.duration = 0
    this.setState({ duration: 0, dataDate: new Date() })

    this._onSearchUsers()
  }

  _onCheckUser (userId, bChecked) {
    this._users.forEach(user => {
      user.checked = false

      if (user.id === userId) {
        user.checked = bChecked
      }
    })

    this._task.userId = bChecked ? userId : null
    this._onSaveField('userId')
    this.setState({ dataDate: new Date() })
  }

  _onDeleteUser (userId, ev) {
    ev.preventDefault()
    ev.stopPropagation()

    this._excludeUserIds.push(userId)

    this.setState({ dataDate: new Date() })
  }

  showEditTask (task, isViewMode = false) {
    this._nextSubtaskId = 1
    this._isViewMode = isViewMode || false

    this._task = _.cloneDeep(task)
    this._users = []
    this._task.skills = this._task.skills || []
    this._excludeUserIds = []

    if (!this._task.documents) {
      this._task.documents = []
    }

    if (!this._task.schedules) {
      this._task.schedules = []
    }

    // Update render fields for subtasks
    this._task.subtasks.forEach(subtask => {
      subtask._id = this._nextSubtaskId++
    })

    // Load activities based on project
    if (task && task.projectId) {
      this._getProjectBudgetItems(task.projectId)
    } else {
      this._activities = []
    }

    // Load assignees
    this._onSearchUsers()

    this.setState({ showEdit: true, currentTab: 'task', dataDate: new Date() })
  }

  showAddTask (task) {
    this._nextSubtaskId = 1

    const prevProjectId = this._task ? this._task.projectId : null
    this._task = task
    this._users = []
    this._task.skills = this._task.skills || []
    this._excludeUserIds = []

    if (!this._task.documents) {
      this._task.documents = []
    }

    // Load activities based on project
    if (task && task.projectId) {
      if (prevProjectId !== task.projectId) {
        this._getProjectBudgetItems(task.projectId)
      }
    } else {
      this._activities = []
    }

    this.setState({
      showEdit: false,
      currentTab: 'task',
      dataDate: new Date()
    })
  }

  updateTaskInfo (name, value) {
    if (this._task) {
      this._task[name] = value
      this.setState({ dataDate: new Date() })
    }
  }

  /* Event Handlers */
  _onChangeTab (tab) {
    this.setState({ currentTab: tab.ident })
  }

  _onChangeField (name, value) {
    this._task[name] = value

    this.setState({ dataDate: new Date() })

    if (name === 'projectId' && this.props.getProjectBudgetItems) {
      this._getProjectBudgetItems(value)
    } else if (name === 'dueDate') {
      // Refresh assignees
      this._onSearchUsers()
    }
  }

  _onChangeDueDate (value) {
    const prevDate = this._task.dueDate ? new Date(this._task.dueDate) : null
    const newDate = new Date(value)
    this._task.dueDate = newDate
    this.setState({ dataDate: new Date() })

    if (this.props.onChangeDueDate) {
      this.props.onChangeDueDate(newDate, this._task.userId, duration => {
        if (prevDate) {
          _.remove(this._task.schedules, obj =>
            DateUtil.isDateEqual(obj.date, prevDate)
          )
        }

        this._task.schedules.push({
          date: newDate,
          noHours: Math.round(duration / 60)
        })

        this._onSaveField('schedules')
        this.setState({ dataDate: new Date() })
      })
    }

    this._onSearchUsers()
  }

  _onSaveField (name) {
    if (this.state.showEdit) {
      const task = this._task
      if (this.props.onSaveEdit && task) {
        const updateData = { [name]: task[name] }
        this.props.onSaveEdit(task.id, updateData)
      }
    } else if (name === 'title') {
      const task = this._task
      if (this.props.onSaveAdd && task) {
        this.props.onSaveAdd(task)
      }
    }
  }

  _onToggleExpandSubtask (subtask) {
    if (!this._task) return

    // If expand new subtask, close all other subtasks
    if (!subtask._isExpand) {
      this._closeAllSubtasks(this._task)
    }

    subtask._isExpand = !subtask._isExpand

    this.setState({ dataDate: new Date() })
  }

  _onAddSubtask () {
    if (!this._task) return

    // Collapse all other subtasks
    this._closeAllSubtasks(this._task)

    this._task.subtasks.unshift({
      _id: this._nextSubtaskId++,
      title: '',
      description: '',
      _isExpand: true
    })

    this.setState({ dataDate: new Date() })
  }

  _onChangeSubtask (subtask, name, value) {
    subtask[name] = value

    this.setState({ dataDate: new Date() })
  }

  _onSaveSubtask () {
    const task = this._task
    if (this.props.onSaveEdit && task) {
      const updateData = {
        subtasks: this._getSaveObjectSubtasks(task.subtasks)
      }
      this.props.onSaveEdit(task.id, updateData)
    }
  }

  _onToggleCompleteSubtask (isCompleted, subtask) {
    const task = this._task
    if (this.props.onSaveEdit && task) {
      // Make subtask as completed / reopened
      subtask.completed = isCompleted

      const updateData = {
        subtasks: this._getSaveObjectSubtasks(task.subtasks)
      }
      this.props.onSaveEdit(task.id, updateData)
    }
  }

  _onDeleteSubtask (subtask) {
    const task = this._task
    if (this.props.onSaveEdit && task) {
      // Remove subtask from list
      _.remove(task.subtasks, obj => obj._id === subtask._id)

      const updateData = {
        subtasks: this._getSaveObjectSubtasks(task.subtasks)
      }
      this.props.onSaveEdit(task.id, updateData)
    }
  }

  _onToggleCompleteTask (bComplete) {
    const task = this._task
    if (this.props.onSaveEdit && task) {
      task.completed = bComplete

      const updateData = { completed: bComplete }
      this.props.onSaveEdit(task.id, updateData)
    }
  }

  _onChangeUserKeyword (value) {
    this._userKeyword = value
    this._onSearchUsers()
    this.setState({ dataDate: new Date() })
  }

  _onDeleteTask () {
    const task = this._task
    if (this.props.onDelete && task) {
      this.props.onDelete(task.id)
      this._task = null
    }
  }

  _onUploadFile (file, message) {
    const fileObj = { fileName: message.id, fileDisplayName: file.name }
    this._task.documents.push(fileObj)

    this.setState({ dataDate: new Date() })

    const uploaddData = {
      taskId: this._task.id,
      documents: this._task.documents,
      added: [fileObj]
    }

    if (this.props.onUpdateDocuments) {
      this.props.onUpdateDocuments(uploaddData)
    }
  }

  _onDeleteFile (fileIdx) {
    const removedFiles = _.remove(
      this._task.documents,
      (_obj, idx) => idx === fileIdx
    )
    this.setState({ dataDate: new Date() })

    const uploaddData = {
      taskId: this._task.id,
      documents: this._task.documents,
      removed: removedFiles || []
    }

    if (this.props.onUpdateDocuments) {
      this.props.onUpdateDocuments(uploaddData)
    }
  }

  _onChangeSkill (skills, _ev) {
    this._task.skills = skills
    this._onSaveField('skills')

    this.setState({ dataDate: new Date() })

    this._onSearchUsers()
  }

  _onCreateComment = commentData => {
    if (this.props.onCreateComment) {
      this.props.onCreateComment(this._task, commentData)
    }
  }

  _onChangeDurationTime = duration => {
    this._task.duration = duration

    this._onSaveField('duration')
    this.setState({ dataDate: new Date() })

    this._onSearchUsers()
  }

  /* Render function */
  _renderHeader () {
    const { currentTab, showEdit } = this.state
    const bViewMode = Acl.isStandardUser()

    let title = ''

    if (bViewMode) {
      title = 'plannerv2.task.editHeaderTitleView'
    } else if (showEdit) {
      title = 'plannerv2.task.editHeaderTitleTask'
    } else {
      title = 'plannerv2.task.addHeaderTitleTask'
    }

    const tabs = [
      {
        ident: 'task',
        title: 'plannerv2.task.editHeaderTabTask'
      }
    ]

    if (showEdit) {
      tabs.push({
        ident: 'subtask',
        title: 'plannerv2.task.editHeaderTabSubtask'
      })
    }

    return (
      <SidebarHeader
        title={title}
        subtitle={
          showEdit
            ? 'plannerv2.task.editHeaderSubtitle'
            : 'plannerv2.task.addHeaderSubtitle'
        }
        icon='edit'
        tabs={tabs}
        onClose={this._onClose.bind(this)}
        onChangeTab={this._onChangeTab.bind(this)}
        activeTab={currentTab}
        isViewMode={bViewMode}
        showCloseBorder={!!showEdit}
      />
    )
  }

  /* Private functions */
  _getProjectBudgetItems (projectId) {
    const query = {
      type: 'time-activity'
    }

    let phaseNamePrefix = ''
    this.props.getProjectBudgetItems(projectId, query, activities => {
      this._activities = activities.map(activity => {
        if (activity.project) {
          if (activity.project.id === projectId) {
            activity.project.budget.phases.map((phase, idx) => {
              if (activity.phaseNo - 1 === idx && phase.title) {
                phaseNamePrefix = `${phase.title} - `
              }
            })
          }
        }

        return {
          label: `${phaseNamePrefix}${activity.title}`,
          value: activity.id
        }
      })

      this.setState({ dataDate: new Date() })
    })
  }

  _onSearchUsers () {
    let keywords = this._userKeyword ? this._userKeyword.split(' ') : []

    if (this._task.skills) {
      keywords = keywords.concat(this._task.skills)
    }

    const duration = this._task.duration || 0
    const plannedHours = this._task.plannedHours || 0

    let fromDate = null
    let toDate = null
    let bTaskIsInPast = false
    let bDueDateSet = false

    // If due date is set, then search based on due date
    if (this._task && this._task.dueDate) {
      const todayDate = new Date()
      todayDate.setHours(0, 0, 0)

      // Check Duedate is in past
      if (this._task.dueDate < todayDate) {
        bTaskIsInPast = true
      } else {
        bDueDateSet = true

        fromDate = moment().startOf('day')
        toDate = moment(this._task.dueDate).endOf('day')
      }
    }

    // Search the users
    this.props.onSearchUsers(
      'all',
      keywords,
      null,
      fromDate,
      toDate,
      this._task.userId,
      users => {
        const usersAvailable = []
        const usersPartialAvailable = []
        const usersNotAvailable = []

        // Filter out inactive users
        users = users.filter(user => user.status === 'active')

        users.forEach(user => {
          user.checked = false
          if (
            user.id &&
            this._task.userId &&
            user.id === this._task.userId.toString()
          ) {
            user.checked = true
          }

          // If date is past - then make it as not available
          if (bTaskIsInPast) {
            user.scheduleType = 'not-available'
            usersNotAvailable.push(user)
          } else if (!bDueDateSet) {
            // If date is not set, then make it as fully avaialable
            user.scheduleType = 'fully-available'
            usersAvailable.push(user)
          } else {
            // Based on available hours, set it
            const userPlannedHours = user.checked ? plannedHours : 0
            const scheduleType = this._getUserScheduleType(
              user.availabilityHours,
              duration,
              userPlannedHours,
              user.displayName
            )
            user.scheduleType = scheduleType

            if (scheduleType === 'fully-available') {
              usersAvailable.push(user)
            } else if (scheduleType === 'not-available') {
              usersNotAvailable.push(user)
            } else {
              usersPartialAvailable.push(user)
            }
          }
        })

        this._users = usersAvailable.concat(
          usersPartialAvailable,
          usersNotAvailable
        )
        this._excludeUserIds = []
        this.setState({ dataDate: new Date() })
      }
    )
  }

  /* available hours = scheduled hours - planner hours
    1) red - available hours = 0
                 - if duration exceeds the available hours
    2) orange -  if some hours planned in the scheduled hours till the duedate
    3) green -  if no planned hours */
  _getUserScheduleType (availabilityHours, duration, plannedHours, _name) {
    const availHours = availabilityHours * 60 - plannedHours * 60
    if (availHours <= 0) {
      return 'not-available'
    }

    if (availHours >= duration) {
      return 'fully-available'
    }

    return 'partially-available'
  }

  _closeAllSubtasks (task) {
    task.subtasks.forEach(subItem => {
      subItem._isExpand = false
    })
  }

  _getSaveObjectSubtasks (subtasks) {
    const newSubtasks = []
    subtasks.forEach(obj => {
      if (obj.title) {
        newSubtasks.push({
          title: obj.title,
          description: obj.description,
          completed: obj.completed,
          dueDate: obj.dueDate
        })
      }
    })

    return newSubtasks
  }

  _onClose (ev) {
    if (this.props.onClose) {
      this.props.onClose(ev)
    }

    this._task = null
    this.setState({ dataDate: new Date() })
  }
}

export default SidebarTask
